import {
  CORE_LOAD_ALL_LICENSE_REQUEST,
  CORE_LOAD_ALL_LICENSE_SUCCESS,
  CORE_LOAD_ALL_LICENSE_FAILURE,

  CORE_LOAD_ALL_LICENSE_DISPLAY_REQUEST,
  CORE_LOAD_ALL_LICENSE_DISPLAY_SUCCESS,
  CORE_LOAD_ALL_LICENSE_DISPLAY_FAILURE,

  CORE_LOAD_ALL_LICENSE_IOT_REQUEST,
  CORE_LOAD_ALL_LICENSE_IOT_SUCCESS,
  CORE_LOAD_ALL_LICENSE_IOT_FAILURE,

  CORE_LOAD_LICENSE_REQUEST,
  CORE_LOAD_LICENSE_SUCCESS,
  CORE_LOAD_LICENSE_FAILURE,

  REQUEST_STATE
} from '../types'

const initialState = []
  , initialStateObj = {}
  , requestState = REQUEST_STATE
export default {
  allLicense: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_LICENSE_REQUEST:
        return requestState
      case CORE_LOAD_ALL_LICENSE_SUCCESS:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload
        } else return []
      case CORE_LOAD_ALL_LICENSE_FAILURE:
        return initialState
      default:
        return state
    }
  },
  allLicenseDisplay: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_LICENSE_DISPLAY_REQUEST:
        return requestState
      case CORE_LOAD_ALL_LICENSE_DISPLAY_SUCCESS:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload
        } else return []
      case CORE_LOAD_ALL_LICENSE_DISPLAY_FAILURE:
        return initialState
      default:
        return state
    }
  },
  allLicenseIOT: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_LICENSE_IOT_REQUEST:
        return requestState
      case CORE_LOAD_ALL_LICENSE_IOT_SUCCESS:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload
        } else return []
      case CORE_LOAD_ALL_LICENSE_IOT_FAILURE:
        return initialState
      default:
        return state
    }
  },
  licenseInfo: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_LICENSE_REQUEST:
        return requestState
      case CORE_LOAD_LICENSE_SUCCESS:
        if (action.payload && typeof action.payload === 'object' && !Array.isArray(action.payload)) {
          return action.payload
        } else return {}
      case CORE_LOAD_LICENSE_FAILURE:
        return initialStateObj
      default:
        return state
    }
  },
}



// WEBPACK FOOTER //
// ./src/reducers/reducerLicense.js